import { api } from '@/core/api/'

const apiUrl = 'api/edendisputeresolution'

export default {
  getFile(fileId) {
    return api.get(`${apiUrl}/file/${fileId}`)
  },
  getFiles(edenDisputeResolutionId) {
    return api.get(`${apiUrl}/files/${edenDisputeResolutionId}`)
  },
  getHistory(edenDisputeResolutionId, page, pageSize) {
    return api.get(`${apiUrl}/history/${edenDisputeResolutionId}`, { params: { page, pageSize } })
  },
  submit(edenDisputeResolutionId) {
    return api.put(`${apiUrl}/submit/${edenDisputeResolutionId}`)
  },
  buildFiles(edenDisputeResolutionId) {
    return api.put(`${apiUrl}/buildfiles/${edenDisputeResolutionId}`)
  },
  getReportAvailableAcademicYears() {
    return api.get(`${apiUrl}/reportavailableacademicyears`)
  },
  createEdenDisputeResolutionReport(academicYearId) {
    return api.post(`${apiUrl}/createedendisputeresolutionreport/${academicYearId}`)
  },
  getEdenDisputeResolutions(payload) {
    return api.get(`${apiUrl}/edendisputeresolutions`, { params: payload })
  },
  getAvailableAcademicYears() {
    return api.get(`${apiUrl}/availableAcademicYears`)
  },
  getDetail(edenDisputeResolutionId) {
    return api.get(`${apiUrl}/detail?edenDisputeResolutionId=${edenDisputeResolutionId}`)
  },
  saveDetail(payload) {
    return api.put(`${apiUrl}/save`, payload)
  },
  submitReport(params) {
    return api.put(`${apiUrl}/submitmaster`, params)
  },
  getSupportingDocuments(edenDisputeResolutionId, page, pageSize) {
    return api.get(`${apiUrl}/supportingdocuments/${edenDisputeResolutionId}`, { params: { page, pageSize } })
  },
  upsertSupportingDocument(edenDisputeResolutionId, payload) {
    return api.post(`${apiUrl}/supportingdocument/${edenDisputeResolutionId}`, payload)
  },
  getSupportingDocument(documentId) {
    return api.get(`${apiUrl}/supportingdocument/${documentId}`)
  },
  deleteSupportingDocument(documentId) {
    return api.delete(`${apiUrl}/supportingdocument/${documentId}`)
  },
  amend(edenDisputeResolutionId) {
    return api.put(`${apiUrl}/amend/${edenDisputeResolutionId}`)
  },
  publish(edenDisputeResolutionId) {
    return api.put(`${apiUrl}/publish/${edenDisputeResolutionId}`)
  },
}
